import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminNav from "./components/AdminNav.jsx";
import AdminHeader from "./components/AdminHeader.jsx";
import Login from "./components/AdminLogin.jsx";
import AdminControl from "./pages/AdminControlPage.jsx";
import AdminPublications from "./pages/AdminPublications.jsx";
import AdminBlog from "./pages/AdminBlog.jsx";
import AdminSchedule from "./pages/AdminSchedule.jsx";
import AdminGallery from "./pages/AdminGallery.jsx";
import AdminTeam from "./pages/AdminTeampage.jsx";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
      </Routes>
      <div className="admin-main">
        <AdminNav />
        <AdminHeader />
        <div className="admin-content">
          <Routes>
            <Route path="/admincontrol" element={<AdminControl />} />
            <Route path="/adminpublications" element={<AdminPublications />} />
            <Route path="/adminblog" element={<AdminBlog />} />
            <Route path="/adminschedule" element={<AdminSchedule />} />
            <Route path="/admingallery" element={<AdminGallery />} />
            <Route path="/adminteam" element={<AdminTeam />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
